import moment from "moment";
import Swal from "sweetalert2";
import { constants } from "../Constants";
import { validationEmail } from "./response";

export function capitalizeFirstLetter(string) {
  if (string) return string.charAt(0).toUpperCase() + string.slice(1);
  else return null;
}

export function capitalizeEachFirstLetter(str) {
  if (str) {
    if (str.split(" ").length > 0) {
      let name = [];
      str.split(" ").forEach((element) => {
        return name.push(element.charAt(0).toUpperCase() + element.slice(1));
      });
      return name.join(" ");
    } else return str.charAt(0).toUpperCase() + str.slice(1);
  } else return null;
}

export const getCountryName = async () => {
  return fetch(
    "https://geolocation-db.com/json/f9902210-97f0-11eb-a459-b997d30983f1"
  )
    .then((response) => response.json())
    .then((data) => {
      return data.country_name.toLowerCase();
    })
    .catch((err) => {
      console.error(err, " error");
      return "united states";
    });
};

// Crypt string to hash
export const cryptString = (text) => {
  const textToChars = (text) => text.split("").map((c) => c.charCodeAt(0));
  const byteHex = (n) => ("0" + Number(n).toString(16)).substr(-2);
  const applySaltToChar = (code) =>
    textToChars("salt").reduce((a, b) => a ^ b, code);

  return text
    .split("")
    .map(textToChars)
    .map(applySaltToChar)
    .map(byteHex)
    .join("")
    .substring(0, 40);
};

// Decrypt hash back to string
export const decryptString = (encoded) => {
  const textToChars = (text) => text.split("").map((c) => c.charCodeAt(0));
  const applySaltToChar = (code) =>
    textToChars("salt").reduce((a, b) => a ^ b, code);
  return encoded
    .match(/.{1,2}/g)
    .map((hex) => parseInt(hex, 16))
    .map(applySaltToChar)
    .map((charCode) => String.fromCharCode(charCode))
    .join("");
};

export const isPhoneNumber = (number) => {
  if (
    number.keyCode === 69 ||
    number.keyCode === 107 ||
    number.keyCode === 109 ||
    number.keyCode === 110 ||
    number.keyCode === 187 ||
    number.keyCode === 189 ||
    number.keyCode === 190
  )
    number.preventDefault();
};

export const maxLengthCheck = (object) => {
  if (object.target.value.length > object.target.maxLength) {
    object.target.value = object.target.value.slice(0, object.target.maxLength);
  }
};

export const getDateTimeAndDuration = (date_time) => {
  const dateTime = moment(date_time).format('dddd, Do MMM, YYYY');
  const duration = moment(date_time)
    .format('hh:mm A - ')
    .toLocaleString('en-US', {
      hour: 'numeric',
      hour12: true,
    }) +
    moment(date_time)
      .add('1', 'h')
      .format('hh:mm A')

      .toLocaleString('en-US', {
        hour: 'numeric',
        hour12: true,
      });

  return { dateTime, duration };
};

export const validateFields = (name, emailAddress, selectedRelation) => {
  if (!name || !name.trim()) {
    Swal.fire({
      title: constants.FMAILY_MEMBER_ERROR_TEXT,
      text: constants.FMAILY_MEMBER_IVALID_NAME_TXT,
      confirmButtonText: constants.OK_TXT
    });
    return false;
  }
  if (!selectedRelation) {
    Swal.fire({
      title: constants.FMAILY_MEMBER_ERROR_TEXT,
      text: constants.FMAILY_MEMBER_IVALID_RELATION_TXT,
      confirmButtonText: constants.OK_TXT
    });
    return false;
  }
  if (!validationEmail(emailAddress)) {
    Swal.fire({
      title: constants.FMAILY_MEMBER_ERROR_TEXT,
      text: constants.FMAILY_MEMBER_IVALID_EMIAL_TXT,
      confirmButtonText: constants.OK_TXT
    });
    return false;
  }
  return true;
};

export const getSubDomain = () => {
  const host = window.location.host;
  const splittedDomain = host.split('.');
  if (Array.isArray(splittedDomain) && splittedDomain.length > 0) {
    return splittedDomain[0];
  }
  return '';
};

export const updateFavicon = (appType) => {
  const faviconUrl = appType === "cwp" ? "/cwp.ico" : "/favicon.ico";  
  let link = document.querySelector("link[rel*='icon']");
  if (!link) {
    link = document.createElement("link");
    link.type = "image/x-icon";
    link.rel = "shortcut icon";
    document.head.appendChild(link);
  }
  link.href = faviconUrl;
};

export const calculatePageSlots = (pageNumber) => {
  const hoursRequired = 23;
  const daysHours = [];
  const baseStartingPoint = 1;
  const baseDaysRequired = 7;
  const currentHour = new Date().getHours();
  const startingPoint = baseStartingPoint + (pageNumber - 1) * baseDaysRequired;
  const daysRequired = startingPoint + baseDaysRequired - 1;
  for (let v = startingPoint; v <= daysRequired; v++) {
    const dayHours = [];
    for (let i = 0; i <= hoursRequired; i++) {
      const obj = {
        hour: moment().add(i, 'hour').add(v, 'days').subtract(currentHour, 'hours').format('YYYY-MM-DD HH:00:00'),
      };
      dayHours.push(obj);
    }
    daysHours.push(dayHours);
  }

  return daysHours;
};
export const findSlot = (pageArray, targetHour) => {
  for (let dayIndex = 0; dayIndex < pageArray.length; dayIndex++) {
    const hourIndex = pageArray[dayIndex].findIndex(slot => slot.hour === targetHour);
    if (hourIndex !== -1) {
      return { dayIndex, hourIndex };
    }
  }
  return null;
};

export function getSessionsRemaining(total, consumed) {
  return Math.max(0, total - consumed);
}



// WEBPACK FOOTER //
// ./src/helpers/utils.js